<template>
  <div id="app">
    <modal v-if="modalVisible" @close="handleCloseRequest" :type="modalType" :info="countryInformation" />
    <mapComponent
      v-if="countriesInfo"
      :countriesJSON="countriesInfo"
      :legend="legend"
      @open="handleOpenRequest"
      @openTutorial="handleOpenRequest"
    />
  </div>
</template>

<script>
import MapComponent from "./components/Map";
import Modal from "./components/Modal";
import countriesJSON from "./data/countries.js";
import GET_COUNTRIES from "./graphql/GetCountries.gql";

export default {
  name: "app",
  components: {
    modal: Modal,
    mapComponent: MapComponent
  },
  data() {
    return {
      countriesInfo: undefined,
      countriesLegend: [],
      modalType: "welcome",
      modalVisible: true,
      countryInformation: {}
    };
  },
  methods: {
    handleCloseRequest() {
      this.modalVisible = false;
    },
    handleOpenRequest(feature) {
      this.modalVisible = true;
      if (feature) {
        this.countryInformation = feature.properties;
        this.modalType = "country";
      } else {
        this.modalType = "welcome";
      }
    },
    formatCountryData() {
      if (this.countriesWithLinks) {
        const data = this.countriesWithLinks;
        const structure = countriesJSON;
        const legend = [];
        structure.features = data.map((country, index) => {
          legend.push({
            country_id: index,
            country_name: country.name,
            articleCount: index
          });

          return {
            type: "Feature",
            id: `${country.name.toLowerCase()}.fid--${index}`,
            geometry: country.coordinates,
            geometry_name: "geom",
            properties: {
              gid: index,
              dpto: `${index}`,
              name: country.name,
              active: false,
              disabled: !country.linksCount || country.linksCount === 0 ? true : false,
              linksCount: country.linksCount,
              id: country.id
            }
          };
        });
        this.legend = legend;
        this.countriesInfo = structure;
      }
    }
  },
  apollo: {
    countriesWithLinks: {
      query: GET_COUNTRIES,
      result: function() {
        this.formatCountryData();
      }
    }
  }
};
</script>
<style lang="scss"></style>
